import React, {Component} from 'react';
import {FormGroup, FormControl, FormLabel as ControlLabel, Col} from 'react-bootstrap';

export default class TextareaField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			sizes,
			meta: {error, warning, touched, asyncValidating},
			...props
		} = this.props;

		let message;
		const validationState = touched ? ( error && "error" ) || ( warning && "warning" ) || null : null;

		if (touched && ( error || warning )) {
			message = <span className="help-block">{error || warning}</span>;
		}

		return (
			<FormGroup controlId={input.name} validationState={validationState} className={asyncValidating ? "loading" : ""}>
				{label ? <Col xs={sizes && sizes[0] ? sizes[0] : 2} componentClass={ControlLabel}>{label}</Col> : null}
				<Col xs={label ? (sizes && sizes[1] ? sizes[1] : 10) : (sizes && sizes[0] ? sizes[0] : 12)}>
					<FormControl {...props} {...input} componentClass="textarea"/>
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}
